// Client-side format check for the read-only API key the verifier uses
// for the optional online completeness check. This only validates the
// key SHAPE; whether the key actually exists and is read-only is decided
// by the witness service when the completeness request is made. Extracted
// as a pure function so it can be unit-tested without a browser harness.
//
// The shape mirrors the v2 read-only key the witness issues and parses
// (see src/witness/log.ts generateApiKey / API_KEY_V2_REGEX):
//   sq_<env>_ro_<opaqueId>_<kr suffix>_<43 random>
// where opaqueId is 8 base62 chars, the key-id suffix is krN for
// read-only keys (write keys use kwN and have no _ro segment, so they are
// rejected here for safety). Duplicated rather than imported because
// src/witness/log.ts is server-only (pg, node crypto) and cannot be
// bundled into the browser verifier.
export const READ_ONLY_KEY_PATTERN = /^sq_(live|test)_ro_[0-9A-Za-z]{8}_kr\d+_[A-Za-z0-9_-]{43}$/;

export type KeyFormatState =
  | { kind: "empty" }
  | { kind: "valid" }
  | { kind: "invalid"; message: string };

export function evaluateKeyFormat(key: string): KeyFormatState {
  const trimmed = key.trim();
  if (trimmed.length === 0) return { kind: "empty" };
  if (READ_ONLY_KEY_PATTERN.test(trimmed)) return { kind: "valid" };
  return {
    kind: "invalid",
    message:
      "Read-only API key required (sq_live_ro_... or sq_test_ro_...). Write keys are rejected by the verifier for safety."
  };
}
